import { apiCallback } from 'api';

const definition = {
  service: 'reference',
  endpoint: 'reference/campaigns',
  verbs: ['get'],
  defaultVersion: 1,
};

export default {
  get: apiCallback(definition, 'get'),
};
